export default __webpack_public_path__ + "static/media/cooking-radiator.430ace35.svg";